import common from 'common';
const SEI_TYPE = {
  1: 'teacher_send_quick_question',
  2: 'teacher_change_coin',
  3: 'teacher_send_task',
  4: 'teacher_send_task',
  5: 'teacher_send_task',
  6: 'teacher_send_task',
  7: 'teacher_send_task',
  8: 'pk',
  9: 'switch_soe',
};
export default function compareTime(status, res, callback) {
  let questionList = common.getSession('questionList');
  let coinList = common.getSession('coinList');
  let commentList = common.getSession('commentList');
  let questionCloseList = common.getSession('questionCloseList');
  let rankList = common.getSession('rankList');
  let giftSwitchList = common.getSession('giftSwitchList');
  let pkList = common.getSession('pkList');
  if (status == 0) {
    if (checkData(questionList) && checkTime(questionList, res)) {

      dispatch(1, res, callback);
    }
    if (checkData(commentList) && checkTime(commentList, res)) {
      dispatch(3, res, callback);
    }
    if (checkData(coinList)) {
      for (let v in coinList) {
        if (checkTime(coinList[v], res)) {
          res.uuid = coinList[v].datas.unique_id;
          dispatch(2, res, callback);
        }
      }
    }
    if (checkData(questionCloseList) && checkTime(questionCloseList, res)) {

      dispatch(4, res, callback);
    }
    if (checkData(rankList) && checkTime(rankList, res)) {

      if (rankList.datas.data.task_name == 'badge_ranking') {
        dispatch(5, res, callback);
      } else if (rankList.datas.data.task_name == 'question_ranking') {
        dispatch(6, res, callback);
      }
    }
    if (checkData(giftSwitchList) && checkTime(giftSwitchList, res)) {

      dispatch(7, res, callback);
    }
    if (checkData(pkList) && checkTime(pkList, res)) {

      dispatch(8, res, callback);
    }

  } else {

    dispatch(status, res, callback);
  }
}
function checkData(data) {
  return data && JSON.stringify(data) !== '{}';
}
function checkTime(data, seiData) {
  if (data.canUse) {
    let time = seiData.ts - data.datas.data.srv_time;
    return time >= 4 || Math.abs(time) >= 20;
  }
  return false;
}
function dispatch(status, res, callback) {
  let datas = {};
  let specialData = {};
  let commonData = {
    lesson_id: res.lid,
    srv_time: res.ts, //发题时间
    ots_time: res.ots, //obs时间
    type: res.type,
    teacher_id: res.uid,
  };

  switch (status) {
    case 1:
      specialData = {
        quick_question_id: res.id,
      };
      break;
    case 2:
      specialData = {
        coin: res.count,
      };
      break;
    case 3:
      specialData = {
        task_name: 'comments',
        task_data: {
          show: res.show,
        },
      };
      break;
    case 4:
      specialData = {
        task_name: 'end_question',
        task_data: {
          close: res.uuid,
          question_id: res.question_id,
        },
      };
      break;
    case 5:
      specialData = {
        task_name: 'badge_ranking',
        task_data: {
          unique_id: res.uuid,
          batch_id: res.batch_id,
        },
      };
      break;
    case 6:
      specialData = {
        task_name: 'question_ranking',
        task_data: {
          unique_id: res.uuid,
        },
      };
      break;
    case 7:
      specialData = {
        task_name: 'giftSwitch',
        task_data: {
          unique_id: res.uuid,
          state: res.state,
        },
      };
      break;
    case 8:
      let pkList = common.getSession('pkList');
      specialData = {
        sub_type: res.sub_type || (pkList && pkList.datas.data.sub_type),
        unique_id: res.uuid,
      };
      break;
    case 9:
      //不需要组装数据
      break;
  }
  Object.assign(commonData, specialData);
  datas.type = SEI_TYPE[status];
  datas.unique_id = res.uuid;
  datas.data = commonData;
  let filterData = common.get('filterData') || {};
  filterData = filterData[common.getSession('lesson_id')] || {};
  let coinFilterData = filterData.msgList || [];
  let isCoin = false;
  if (
    status == 2 &&
    res.type &&
    res.type != 'normal_listen_lesson' &&
    !coinFilterData.includes(res.uuid)
  ) {
    isCoin = true;
  }
  callback(datas, isCoin);
}



// WEBPACK FOOTER //
// ./src/js/seiUtils.js